import { clientBenefits } from '../../data/content';
import './ClientBenefits.css';

function ClientBenefits() {
  return (
    <section id="beneficios" className="section client-benefits">
      <div className="container">
        <div className="section-header">
          <h2>O que sua empresa ganha</h2>
          <p>Benefícios reais que impactam o dia a dia de cada área.</p>
        </div>

        <div className="benefits-grid">
          {clientBenefits.map((item) => (
            <div key={item.title} className="benefit-card">
              <span className="benefit-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientBenefits;
